import React from 'react';
import FormField from '../../../components/forms/FormField';
import { useFormContext } from 'react-hook-form';

export default function CaracterizacaoSocioeconomica() {
  const { watch } = useFormContext();
  
  const setoresEconomicos = watch('setores_economicos');
  const mostraOutraPosicao = Array.isArray(setoresEconomicos) && setoresEconomicos.includes('outro');
  
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação socioeconômica do município. Utilize dados oficiais sempre que possível.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        name="pib_municipal"
        label="PIB Municipal (R$)"
        type="currency"
        placeholder="Digite o valor do PIB municipal"
        helpText="Valor em reais do último PIB municipal divulgado"
      />
      
      <FormField
        name="participacao_pib"
        label="Participação no PIB da RIDE (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem que o município representa no PIB total da RIDE-DF"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
    </div>

    <div className="mt-4">
      <FormField
        name="taxa_desemprego"
        label="Taxa de desemprego (%)"
        type="percent"
        placeholder="Digite a taxa de desemprego"
        helpText="Taxa de desemprego conforme última pesquisa oficial"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
    </div>

    <div className="mt-4">
      <FormField
        name="setores_economicos"
        label="Setores econômicos predominantes (máximo 3)"
        type="checkbox"
        options={[
          { value: 'agropecuaria', label: 'Agropecuária' },
          { value: 'industria', label: 'Indústria' },
          { value: 'comercio', label: 'Comércio' },
          { value: 'servicos', label: 'Serviços' },
          { value: 'tecnologia', label: 'Tecnologia' },
          { value: 'energia', label: 'Energia' },
          { value: 'outro', label: 'Outro' },
        ]}
        helpText=""
      />
    {mostraOutraPosicao && (
      <div className="mt-2">
        <FormField
          name="setores_economicos_outro"
          label="Especifique outro setor econômico"
          placeholder="Descreva o setor econômico"
          helpText="Preencha apenas se selecionou 'Outro' acima"
        />
      </div>
    )}
    
      <div className="mt-4">
        <FormField
          name="exportacoes_importacoes"
          label="Exportações e importações anuais"
          type="textarea"
          placeholder="Descreva os principais produtos exportados e importados e seus valores aproximados"
          helpText=""
        />
      </div>
    
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="renda_per_capita"
          label="Renda média per capita (R$)"
          type="currency"
          placeholder="Digite a renda média per capita"
          helpText="Valor em reais da renda média por habitante"
        />
        
        <FormField
          name="taxa_pobreza"
          label="Taxa de pobreza (%)"
          type="percent"
          placeholder="Digite a taxa de pobreza"
          helpText="Porcentagem da população abaixo da linha de pobreza"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
    
      <div className="mt-4">
        <FormField
          name="desafios_socioeconomicos"
          label="Principais desafios socioeconômicos relatados"
          type="textarea"
          placeholder="Descreva os principais desafios socioeconômicos do município"
          helpText=""
        />
      </div>
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao2"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao2"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
